import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_59de254c from 'nuxt_plugin_plugin_59de254c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_7ac07ac2 from 'nuxt_plugin_plugin_7ac07ac2' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_sliderplugin244b3c80_08b58b22 from 'nuxt_plugin_sliderplugin244b3c80_08b58b22' // Source: ./slider.plugin.244b3c80.js (mode: 'all')
import nuxt_plugin_selectbuttonplugin3043570d_7f05babb from 'nuxt_plugin_selectbuttonplugin3043570d_7f05babb' // Source: ./selectbutton.plugin.3043570d.js (mode: 'all')
import nuxt_plugin_inputnumberplugin102ceb44_6d29ee99 from 'nuxt_plugin_inputnumberplugin102ceb44_6d29ee99' // Source: ./inputnumber.plugin.102ceb44.js (mode: 'all')
import nuxt_plugin_dropdownplugin61ff3da0_fb708162 from 'nuxt_plugin_dropdownplugin61ff3da0_fb708162' // Source: ./dropdown.plugin.61ff3da0.js (mode: 'all')
import nuxt_plugin_checkboxplugin27bfc262_79a50d78 from 'nuxt_plugin_checkboxplugin27bfc262_79a50d78' // Source: ./checkbox.plugin.27bfc262.js (mode: 'all')
import nuxt_plugin_autocompleteplugin089e7747_3e9e0a48 from 'nuxt_plugin_autocompleteplugin089e7747_3e9e0a48' // Source: ./autocomplete.plugin.089e7747.js (mode: 'all')
import nuxt_plugin_configplugin180d81a1_2eed8856 from 'nuxt_plugin_configplugin180d81a1_2eed8856' // Source: ./config.plugin.180d81a1.js (mode: 'all')
import nuxt_plugin_gtm_62729b74 from 'nuxt_plugin_gtm_62729b74' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_appinsightsserver_0ee7e013 from 'nuxt_plugin_appinsightsserver_0ee7e013' // Source: ./appinsights.server.js (mode: 'server')
import nuxt_plugin_appinsightsclient_ada322ea from 'nuxt_plugin_appinsightsclient_ada322ea' // Source: ./appinsights.client.js (mode: 'client')
import nuxt_plugin_dayjsplugin_7b50cb6d from 'nuxt_plugin_dayjsplugin_7b50cb6d' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_axios_ce0e6120 from 'nuxt_plugin_axios_ce0e6120' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_c10f266a from 'nuxt_plugin_pluginutils_c10f266a' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_5910f356 from 'nuxt_plugin_pluginrouting_5910f356' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_1c7ea7d9 from 'nuxt_plugin_pluginmain_1c7ea7d9' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_graphqlrequest_29c0574a from 'nuxt_plugin_graphqlrequest_29c0574a' // Source: ./graphql-request.js (mode: 'all')
import nuxt_plugin_signalrclient_5db08253 from 'nuxt_plugin_signalrclient_5db08253' // Source: ../../../plugins/signalr-client.js (mode: 'client')
import nuxt_plugin_signalrregisterevents_693f3b6d from 'nuxt_plugin_signalrregisterevents_693f3b6d' // Source: ../../../plugins/signalr-register-events.js (mode: 'client')
import nuxt_plugin_freshworkswidget_733fd630 from 'nuxt_plugin_freshworkswidget_733fd630' // Source: ../../../plugins/freshworks-widget.js (mode: 'client')
import nuxt_plugin_detectoffline_b89de430 from 'nuxt_plugin_detectoffline_b89de430' // Source: ../../../plugins/detect-offline.js (mode: 'client')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../../../plugins/axios (mode: 'client')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../../../plugins/i18n.js (mode: 'client')
import nuxt_plugin_datolink_168d851e from 'nuxt_plugin_datolink_168d851e' // Source: ../../../plugins/dato-link.js (mode: 'client')
import nuxt_plugin_productutils_ee253b8c from 'nuxt_plugin_productutils_ee253b8c' // Source: ../../../plugins/product-utils.js (mode: 'client')
import nuxt_plugin_dialogs_7f30ee62 from 'nuxt_plugin_dialogs_7f30ee62' // Source: ../../../plugins/components/dialogs.js (mode: 'client')
import nuxt_plugin_format_a2b35946 from 'nuxt_plugin_format_a2b35946' // Source: ../../../plugins/components/format.js (mode: 'client')
import nuxt_plugin_matchesbreakpoint_04e302ee from 'nuxt_plugin_matchesbreakpoint_04e302ee' // Source: ../../../plugins/components/matches-breakpoint.js (mode: 'client')
import nuxt_plugin_optionalvalues_0b86c34b from 'nuxt_plugin_optionalvalues_0b86c34b' // Source: ../../../plugins/components/optional-values.js (mode: 'client')
import nuxt_plugin_toastutils_19ae44fc from 'nuxt_plugin_toastutils_19ae44fc' // Source: ../../../plugins/toast-utils.js (mode: 'all')
import nuxt_plugin_idpusermanager_5a73141e from 'nuxt_plugin_idpusermanager_5a73141e' // Source: ../../../plugins/idp-user-manager.js (mode: 'all')
import nuxt_plugin_meta_00ac1e54 from 'nuxt_plugin_meta_00ac1e54' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":(titleChunk) =>
    titleChunk ? `${titleChunk} - THE SWEX` : 'THE SWEX',"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, viewport-fit=cover"},{"hid":"description","name":"description","content":""},{"name":"theme-color","content":"#006db6"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.png"},{"rel":"dns-prefetch","href":"https:\u002F\u002Fgraphql.datocms.com\u002F"},{"hid":"canonical","rel":"canonical","href":"https:\u002F\u002Ftheswex.com"}],"script":[{"src":"\u002Ftracking.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_59de254c === 'function') {
    await nuxt_plugin_plugin_59de254c(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_7ac07ac2 === 'function') {
    await nuxt_plugin_plugin_7ac07ac2(app.context, inject)
  }

  if (typeof nuxt_plugin_sliderplugin244b3c80_08b58b22 === 'function') {
    await nuxt_plugin_sliderplugin244b3c80_08b58b22(app.context, inject)
  }

  if (typeof nuxt_plugin_selectbuttonplugin3043570d_7f05babb === 'function') {
    await nuxt_plugin_selectbuttonplugin3043570d_7f05babb(app.context, inject)
  }

  if (typeof nuxt_plugin_inputnumberplugin102ceb44_6d29ee99 === 'function') {
    await nuxt_plugin_inputnumberplugin102ceb44_6d29ee99(app.context, inject)
  }

  if (typeof nuxt_plugin_dropdownplugin61ff3da0_fb708162 === 'function') {
    await nuxt_plugin_dropdownplugin61ff3da0_fb708162(app.context, inject)
  }

  if (typeof nuxt_plugin_checkboxplugin27bfc262_79a50d78 === 'function') {
    await nuxt_plugin_checkboxplugin27bfc262_79a50d78(app.context, inject)
  }

  if (typeof nuxt_plugin_autocompleteplugin089e7747_3e9e0a48 === 'function') {
    await nuxt_plugin_autocompleteplugin089e7747_3e9e0a48(app.context, inject)
  }

  if (typeof nuxt_plugin_configplugin180d81a1_2eed8856 === 'function') {
    await nuxt_plugin_configplugin180d81a1_2eed8856(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_62729b74 === 'function') {
    await nuxt_plugin_gtm_62729b74(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_appinsightsserver_0ee7e013 === 'function') {
    await nuxt_plugin_appinsightsserver_0ee7e013(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_appinsightsclient_ada322ea === 'function') {
    await nuxt_plugin_appinsightsclient_ada322ea(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_7b50cb6d === 'function') {
    await nuxt_plugin_dayjsplugin_7b50cb6d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_ce0e6120 === 'function') {
    await nuxt_plugin_axios_ce0e6120(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_c10f266a === 'function') {
    await nuxt_plugin_pluginutils_c10f266a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_5910f356 === 'function') {
    await nuxt_plugin_pluginrouting_5910f356(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_1c7ea7d9 === 'function') {
    await nuxt_plugin_pluginmain_1c7ea7d9(app.context, inject)
  }

  if (typeof nuxt_plugin_graphqlrequest_29c0574a === 'function') {
    await nuxt_plugin_graphqlrequest_29c0574a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_signalrclient_5db08253 === 'function') {
    await nuxt_plugin_signalrclient_5db08253(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_signalrregisterevents_693f3b6d === 'function') {
    await nuxt_plugin_signalrregisterevents_693f3b6d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_freshworkswidget_733fd630 === 'function') {
    await nuxt_plugin_freshworkswidget_733fd630(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_detectoffline_b89de430 === 'function') {
    await nuxt_plugin_detectoffline_b89de430(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_datolink_168d851e === 'function') {
    await nuxt_plugin_datolink_168d851e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_productutils_ee253b8c === 'function') {
    await nuxt_plugin_productutils_ee253b8c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dialogs_7f30ee62 === 'function') {
    await nuxt_plugin_dialogs_7f30ee62(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_format_a2b35946 === 'function') {
    await nuxt_plugin_format_a2b35946(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_matchesbreakpoint_04e302ee === 'function') {
    await nuxt_plugin_matchesbreakpoint_04e302ee(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_optionalvalues_0b86c34b === 'function') {
    await nuxt_plugin_optionalvalues_0b86c34b(app.context, inject)
  }

  if (typeof nuxt_plugin_toastutils_19ae44fc === 'function') {
    await nuxt_plugin_toastutils_19ae44fc(app.context, inject)
  }

  if (typeof nuxt_plugin_idpusermanager_5a73141e === 'function') {
    await nuxt_plugin_idpusermanager_5a73141e(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_00ac1e54 === 'function') {
    await nuxt_plugin_meta_00ac1e54(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
